import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWork = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#1f1f1f",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M160-120q-33 0-56.5-23.5T80-200v-440q0-33 23.5-56.5T160-720h160v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h160q33 0 56.5 23.5T880-640v440q0 33-23.5 56.5T800-120H160Zm240-600h160v-80H400v80Z" })
});
export default SvgWork;
